import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { RunFlags } from '../../../../StayTimeline.items'
import { GuestInboxTimelineEvent } from '../../../../StayTimeline.types'
import { getEventWhen } from '../../../../StayTimeline.utils'
import { ChannelTag } from '../../../ChannelTag'
import { DeliveryStatus } from '../../../DeliveryStatus'
import { TimelineAvatar } from '../../../TimelineAvatar'
import { MessageAttachments, stripAttachmentPlaceholders } from '../MessageAttachments'
import { MessageBubble } from '../MessageBubble'
import * as Bubble from '../MessageBubble/MessageBubble.styles'
import { MessageMarkdown } from '../MessageMarkdown'
import * as S from './TeamMessage.styles'

interface TeamMessageProps {
  event: GuestInboxTimelineEvent
  flags: RunFlags
  isAi?: boolean
  checkIn?: IDate | null
  checkout?: IDate | null
}

export const TeamMessage = ({
  event,
  flags,
  isAi = false,
  checkIn,
  checkout,
}: TeamMessageProps) => {
  const name = event.who || (isAi ? 'Duckie' : 'AvantStay')
  const body = stripAttachmentPlaceholders(event)

  return (
    <MessageBubble
      isInbound={false}
      flags={flags}
      avatar={<TimelineAvatar name={name} variant={isAi ? 'bot' : 'teammate'} />}
      header={
        <>
          <ChannelTag channel={event.channel} medium={event.medium} />
          <Bubble.Name $isAi={isAi}>{name}</Bubble.Name>
        </>
      }
    >
      {body ? (
        <Bubble.Bubble
          as="div"
          $variant={isAi ? 'ai' : 'out'}
          $isRunStart={flags.isFirst}
          $deliveryStatus={event.deliveryStatus}
        >
          <MessageMarkdown body={body} />
        </Bubble.Bubble>
      ) : null}

      <MessageAttachments isInbound={false} attachments={event.attachments} />

      <DeliveryStatus status={event.deliveryStatus} error={event.deliveryError} />
      {isAi ? <S.AiCaption>resolved without a human</S.AiCaption> : null}
      {flags.isLast ? <Bubble.When>{getEventWhen(event.at, checkIn, checkout)}</Bubble.When> : null}
    </MessageBubble>
  )
}
